import ModalWrapper from "../ui/ModalWrapper";
import "./FramesModal.scss";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedFrame, setSelectedFrameModalCategory } from "../../store/customizerSlice";
import { useMemo, useState } from "react";
import SearchField from "./SearchField";

const customAllFramesOrder = [
  // Standard frames
  "/frames/artistic-frame-18.png",
  "/frames/artistic-frame-19.png",
  "/frames/artistic-frame-14.png",
  "/frames/artistic-frame-15.png",
  "/frames/artistic-frame-16.png",
  "/frames/artistic-frame-17.png",
  "/frames/artistic-frame-20.png",
  "/frames/standard-frame-1.png",
  "/frames/standard-frame-2.png",
  "/frames/standard-frame-3.png",
  "/frames/standard-frame-4.png",
  "/frames/standard-frame-5.png",
  "/frames/standard-frame-6.png",
  "/frames/standard-frame-7.png",
  "/frames/standard-frame-8.png",
  "/frames/standard-frame-9.png",
  "/frames/standard-frame-10.png",
  "/frames/standard-frame-11.png",
  "/frames/standard-frame-12.png",
  "/frames/standard-frame-13.png",
  "/frames/standard-frame-14.png",
  "/frames/artistic-frame-1.png",
  "/frames/artistic-frame-2.png",
  "/frames/artistic-frame-3.png",
  "/frames/artistic-frame-4.png",
  "/frames/artistic-frame-5.png",
  "/frames/artistic-frame-6.png",
  "/frames/artistic-frame-7.png",
  "/frames/artistic-frame-8.png",
  "/frames/artistic-frame-9.png",
  "/frames/artistic-frame-10.png",
  "/frames/artistic-frame-11.png",
  "/frames/artistic-frame-12.png",
  "/frames/artistic-frame-13.png",

  // Holidays frames
  "/frames/holidays-frame-21.png",
  "/frames/holidays-frame-22.png",
  "/frames/holidays-frame-23.png",
  "/frames/holidays-frame-24.png",
  "/frames/holidays-frame-25.png",
  "/frames/holidays-frame-26.png",
  "/frames/holidays-frame-27.png",
  "/frames/holidays-frame-1.png",
  "/frames/holidays-frame-2.png",
  "/frames/holidays-frame-3.png",
  "/frames/holidays-frame-4.png",
  "/frames/holidays-frame-5.png",
  "/frames/holidays-frame-6.png",
  "/frames/holidays-frame-7.png",
  "/frames/holidays-frame-8.png",
  "/frames/holidays-frame-9.png",
  "/frames/holidays-frame-10.png",
  "/frames/holidays-frame-11.png",
  "/frames/holidays-frame-12.png",
  "/frames/holidays-frame-13.png",
  "/frames/holidays-frame-14.png",
  "/frames/holidays-frame-15.png",
  "/frames/holidays-frame-16.png",
  "/frames/holidays-frame-17.png",
  "/frames/holidays-frame-18.png",
  "/frames/holidays-frame-19.png",
  "/frames/holidays-frame-20.png",

  // Birthdays frames
  "/frames/birthday-frame-8.png",
  "/frames/birthday-frame-9.png",
  "/frames/birthday-frame-10.png",
  "/frames/birthday-frame-11.png",
  "/frames/birthday-frame-12.png",
  "/frames/birthday-frame-1.png",
  "/frames/birthday-frame-2.png",
  "/frames/birthday-frame-3.png",
  "/frames/birthday-frame-4.png",
  "/frames/birthday-frame-5.png",
  "/frames/birthday-frame-6.png",
  "/frames/birthday-frame-7.png",

  // Occasions frames
  "/frames/occasions-frame-17.png",
  "/frames/occasions-frame-18.png",
  "/frames/occasions-frame-19.png",
  "/frames/occasions-frame-20.png",
  "/frames/occasions-frame-21.png",
  "/frames/occasions-frame-1.png",
  "/frames/occasions-frame-2.png",
  "/frames/occasions-frame-3.png",
  "/frames/occasions-frame-4.png",
  "/frames/occasions-frame-5.png",
  "/frames/occasions-frame-6.png",
  "/frames/occasions-frame-7.png",
  "/frames/occasions-frame-8.png",
  "/frames/occasions-frame-9.png",
  "/frames/occasions-frame-10.png",
  "/frames/occasions-frame-11.png",
  "/frames/occasions-frame-12.png",
  "/frames/occasions-frame-13.png",
  "/frames/occasions-frame-14.png",
  "/frames/occasions-frame-15.png",
  "/frames/occasions-frame-16.png",
  "/frames/campaigns/ilmd-frame.png",
];

const FramesModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const frames = useSelector((state) => state.customizer.frames);
  const selectedFrame = useSelector((state) => state.customizer.selectedFrame);
  const categories = useSelector((state) => state.customizer.framesModalCategories);
  const selectedCategory = useSelector((state) => state.customizer.selectedFrameModalCategory);
  const [query, setQuery] = useState("");
  const [isSearchVisible, setIsSearchVisible] = useState(true);


  const filteredFrames = useMemo(() => {
    let categoryFiltered =
      selectedCategory === "All"
        ? [...frames]
        : frames.filter((f) => f.category === selectedCategory);

    if (selectedCategory === "All") {
      categoryFiltered.sort((a, b) => {
        const indexA = customAllFramesOrder.indexOf(a.url);
        const indexB = customAllFramesOrder.indexOf(b.url);

        return (
          (indexA !== -1 ? indexA : Infinity) -
          (indexB !== -1 ? indexB : Infinity)
        );
      });
    }

    if (!query.trim()) return categoryFiltered;

    return categoryFiltered.filter((f) =>
      f.desc?.toLowerCase().includes(query.trim().toLowerCase())
    );
  }, [frames, selectedCategory, query]);

  const onCloseHandler = (e) => {
    e.stopPropagation();
    onClose();
    setQuery("");
    dispatch(setSelectedFrameModalCategory("All"));
  };


  return (
    <ModalWrapper isOpen={isOpen} onClose={onCloseHandler} center={true} className="frames-modal">
      <div className="p-4 w-full">
        <div className="flex items-center justify-center mb-4">
          <h4 className="font-semibold">Browse All Backgrounds</h4>
        </div>
        <div className="flex justify-center items-center flex-col w-full">
          <div className="mb-4 max-w-sm w-full">
            <SearchField
              searchQuery={query}
              setQuery={setQuery}
              isSearchVisible={isSearchVisible}
              setIsSearchVisible={setIsSearchVisible}
            />
          </div>
          <div className="flex flex-wrap justify-center gap-2 mb-4">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => dispatch(setSelectedFrameModalCategory(cat))}
                className={`frame-category px-3 py-1 rounded-10 transition ${selectedCategory === cat ? "selected" : ""
                  }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 overflow-y-auto max-h-[60vh] pr-2">
          {filteredFrames.map((frame, index) => (
            <button
              key={index}
              onClick={() => { dispatch(setSelectedFrame(frame)), onClose(), dispatch(setSelectedFrameModalCategory("All")); }}
              className={`relative bg-modal-buttons w-full rounded-10 overflow-hidden border-2 transition ${selectedFrame.url === frame.url ? "selected" : ""
                }`}
            >
              <img src={frame.url} alt={`Frame ${index + 1}`} className="relative w-full h-full object-cover z-10" />
            </button>
          ))}
          {!filteredFrames.length && (
            <p className="text-center col-span-full text-gray-500 mt-10 mb-10">No backgrounds found</p>
          )}
        </div>
      </div>
    </ModalWrapper>
  );
};

export default FramesModal;
